import { getDefaultExportFromCjs as o } from "./index135.mjs";
import { a } from "./index136.mjs";
import { x as t } from "./index137.mjs";
import { x as s } from "./index138.mjs";
import { x } from "./index139.mjs";
import { x as m } from "./index140.mjs";
import { t as p } from "./index141.mjs";
import { s as e } from "./index142.mjs";
var i = a, f = t, v = s, E = x, d = m, h = p, r = e;
r.alea = i;
r.xor128 = f;
r.xorwow = v;
r.xorshift7 = E;
r.xor4096 = d;
r.tychei = h;
var w = r;
const D = /* @__PURE__ */ o(w);
export {
  D as default
};
